<template>
  <!-- 服务费配置 -->
  <div>
    <cover v-show="firstEntryPage" @on-direct="directFee" @on-template="templateFee" @on-back="directFee" :coverShowBack="coverShowBack"></cover>
    <div class="commission-config main-container" v-show="!firstEntryPage">
      <!-- 组织机构 -->
      <div class="wrapper">
        <loading :isShow="tableLoading" />
        <orgTree
          ref="tree2"
          source="1"
          @change="treeChange"
          :style="{ 'width': leftWidth - 15 + 'px' }"
          :showConfigTemplateText="true"
                  ></orgTree>
        <move-line @move="leftWidth = $event" :style="{ 'left': leftWidth - 5 + 'px' }"></move-line>
        <div class="right-panel" :style="{ 'width': 'calc(100vw - ' + (leftWidth - 15) + ')px' }">
          <div class="top-Bar">
            <div class="breadCrumbBox">
              <Breadcrumb separator=">">
                <BreadcrumbItem v-for="item in navList" :key="item.id">
                  {{ item.name }}
                </BreadcrumbItem>
              </Breadcrumb>
            </div>
            <div class="top-info">
              <div class="name-box">
                <span class="name">{{ detail.name }}</span>
                <span class="tag" v-if="detail.orgType == 1">总部</span>
                <span class="tag" v-else-if="detail.orgType == 2">省分</span>
                <span class="tag" v-else-if="detail.orgType == 3">市级</span>
                <span class="tag" v-else-if="detail.orgType == 4">区级</span>
                <span class="tag" v-else-if="detail.orgType == 5">渠道</span>
                <span class="tag" v-else-if="detail.orgType == 6">营业部</span>
                <span class="tag" v-else>团队</span>
              </div>

              <div class="tips-box">
                <template v-if="!detail.isTop && detail.id != userInfo.organId">
                  <a class="no-template" @click="noTemplate" v-if="templateDetail.id">不再应用模板</a>
                  <span class="tip-icon" @mouseenter="showRuleTips=true;" @mouseleave="showRuleTips = false;">?</span>
                  <div class="pop-tip" v-if="showRuleTips">
                    <span class="title">调整规则：按照原费率在上级费率中的占比进行调整</span>
                    <div>如，上级为80%，下级为40%，即下级占上级费率的50%，当上级下调至30%时，系统将自动根据上下级的原服务费占比，进行下调，即下级调至15%）</div>
                    <div class="arrow"></div>
                  </div>
                  <span @mouseenter="showRuleTips=true;" @mouseleave="showRuleTips = false;" class="fee-tips">费率调整说明</span>
                </template>

                <span class="config-text">
                  <a class="name" @click="showCommissionExplain">费用配置方式介绍</a>
                </span>
              </div>
            </div>
            <div class="top-info" v-if="!detail.isTop && detail.id!=userInfo.organId">
              <div class="name-box" v-if="templateDetail.id">
                <span class="label">当前使用模板：</span>
                <span class="text pointer" @click="goTemplateDetail">{{ templateDetail.name }}</span>
              </div>
              <div class="name-box" v-else>
                <span class="label">暂未应用费率模板</span>
              </div>

              <div class="name-box" v-if="templateDetail.id && detail.parentId != '0'">
                <Button type="primary" class="name-box-btn" ghost
                  @click="openChangeTemplate('updateTemplateVisible')">变更模板</Button>
                <Button type="primary" class="name-box-btn2" ghost @click="recoveryTemplate">恢复模板费率</Button>
              </div>
              <div class="name-box set-template-btn" v-else-if="detail.parentId != '0'">
                <Button type="primary" class="name-box-btn" ghost
                  @click="openChangeTemplate('setTemplateVisible')">设置模板</Button>
              </div>
              <div class="name-box copy-product">
                <Button type="primary" class="name-box-btn" ghost @click="inheritProductRate" :disabled="copyProductRate">复制上级产品和费率</Button>
                <span class="tip-icon">?</span>
                <div class="pop-tip">
                  <span class="title">100%复制上级的产品和费率，复制后可修改</span>
                  <div class="arrow"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="main-panel">
            <div class="search-box ban3" :class="{'open':searchMore}">
              <div class="input-item">
                <span class="label">产品名称</span>
                <Input clearable v-model="search.productName" placeholder="请输入" />
              </div>
              <div class="input-item">
                <span class="label">产品编码</span>
                <Input clearable v-model="search.productCode" placeholder="请输入" />
              </div>
              <div class="input-item">
                <span class="label">保险公司</span>
                <Select v-model="search.companyCode" clearable transfer filterable style="height:30px;">
                  <Option v-for="(item, index) in companyList" :value="item.code" :key="index">{{ item.name }}</Option>
                </Select>
              </div>
              <div class="input-item">
                <span class="label">长短险标志</span>
                <RadioGroup v-model="search.productType">
                  <Radio label="">全部</Radio>
                  <Radio label="1">长险</Radio>
                  <Radio label="2">短险</Radio>
                </RadioGroup>
              </div>
              <div class="input-item">
                <span class="label">险种分类</span>
                <Select v-model="search.themeId" clearable transfer>
                  <Option v-for="(item, index) in themeList" :value="item.id" :key="index">{{ item.name }}</Option>
                </Select>
              </div>
              <div class="input-item" v-if="$units.showSupplier() && $units.pointAction('commission_10_6')">
                <span class="label">供应商类型</span>
                <RadioGroup v-model="search.supplierType" @on-change="changeOriginSupplierType">
                  <Radio label="">全部</Radio>
                  <Radio label="1">保司</Radio>
                  <Radio label="2">通道</Radio>
                </RadioGroup>
              </div>
              <div v-if="search.supplierType&&$units.showSupplier() && $units.pointAction('commission_10_6')"  class="input-item">
                <span class="label">供应商</span>
                <Select v-model="search.supplierIds" multiple clearable filterable transfer>
                  <Option v-for="item in supplierList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                </Select>
              </div>
              <div class="input-item">
                <span class="label">是否活动产品</span>
                <RadioGroup v-model="search.isAct" @on-change="searchFun">
                  <Radio label="">全部</Radio>
                  <Radio label="1">是</Radio>
                  <Radio label="0">否</Radio>
                </RadioGroup>
              </div>
              <div class="input-item">
                <span class="label">上架状态</span>
                <RadioGroup v-model="search.publishStatus" @on-change="searchFun">
                  <Radio label="">全部</Radio>
                  <Radio label="2">已上架</Radio>
                  <Radio label="1">已下架</Radio>
                </RadioGroup>
              </div>
              <div class="input-item">
                <span class="label">是否可售产品</span>
                <RadioGroup v-model="search.salesStatus" @on-change="searchFun">
                  <Radio label="">全部</Radio>
                  <Radio label="2">是</Radio>
                  <Radio label="1">否</Radio>
                </RadioGroup>
              </div>
              <div class="input-item">
                <span class="label">业务类别</span>
                <RadioGroup v-model="search.sellType" @on-change="searchFun">
                  <Radio label="">全部</Radio>
                  <Radio label="1">网销</Radio>
                  <Radio label="3">经代</Radio>
                </RadioGroup>
              </div>
              <div class="input-item">
                <span class="label">是否有费率</span>
                <RadioGroup v-model="search.isThereRate" @on-change="searchFun">
                  <Radio label="">全部</Radio>
                  <Radio label="1">是</Radio>
                  <Radio label="0">否</Radio>
                </RadioGroup>
              </div>
              <div class="btn-item">
                <Button type="primary" @click="searchFun">查询</Button>
                <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
                  >收起<Icon type="ios-arrow-up"
                /></Button>
                <Button type="primary" ghost v-else @click="searchMore = true"
                  >展开<Icon type="ios-arrow-down"
                /></Button>
              </div>
            </div>

            <!-- 工具栏 -->
            <div class="tools-box" v-if="organShow">
              <div class="left-box">
                <Checkbox v-model="isAll" @on-change="selectAll">全部产品</Checkbox>
              </div>
              <div class="right-box">
                <span class="text">已选择<span>{{ isAll ? total : selectArr.length }}</span>项,共<span>{{ total }}</span>款产品</span>
                <Button type="primary" ghost @click="batchDelete">批量删除</Button>
                <Button type="primary" ghost @click="openBatchSetting">批量配费</Button>
                <Button type="warning" @click="openAddProductModal">新增产品</Button>
                <Button type="primary" v-if="$units.superviseShowVal()" ghost @click="detail.id && daochu()">导出当前费率</Button>
                <Button type="primary" v-if="$units.pointAction('commission_10_4') && $units.superviseShowVal()" ghost @click="detail.id && daochuHistory()">导出历史费率</Button>
                <Button type="primary" v-if="$units.superviseShowVal()" @click="importProductFee()">导入费率</Button>
              </div>
            </div>
            <div class="tools-box right" v-else>
              <Button type="primary" ghost v-if="$units.superviseShowVal()" @click="detail.id && daochu()">导出当前费率</Button>
              <Button type="primary" v-if="$units.pointAction('commission_10_4') && $units.superviseShowVal()" ghost @click="detail.id && daochuHistory()">导出历史费率</Button>
            </div>
          </div>

          <!-- 表格 -->
          <div class="table-box">
            <Table ref="table" :columns="changeColumns" :data="tableData" @on-selection-change="onSelectChange">
              <template slot-scope="{ row }" slot="productName">
                <div class="text-left">
                  {{row.productName}}
                  <span class="tag red" v-if="row.isTemplate==0&&templateDetail.id&&!detail.isTop&&detail.id != userInfo.organId">独立费率</span>
                  <span class="tag gray" v-if="row.publishStatus==1">已下架</span>
                  <span class="tag gray" v-if="row.salesStatus==1">停售</span>
                </div>
              </template>
              <template slot-scope="{ row }" slot="insureCost">
                <div>
                  {{ row.insureCost }}元起
                </div>
              </template>
              <template slot-scope="{ row }" slot="fee">
                <div :class="{ 'red-text': row.isTemplate == 0 && templateDetail.id && !detail.isTop && detail.id != userInfo.organId }" style="margin-right:0">
                  <template v-if="row.min != row.max">
                    <span>{{ row.min }}%</span>-<span>{{ row.max }}%</span>
                  </template>
                  <span v-else>{{ row.min }}%</span>
                </div>
                <div v-for="(item, index) in row.activityInfoList" :key="index">
                  <div class="huo" v-if="(detail.nodeType == 2 || detail.levelCode == 10001)&&item.mode == 1">
                    <i>活</i>最高达{{ item.commission }}%
                  </div>
                  <div v-else-if="detail.isTop && item.mode == 2" class="huo-text">
                    <span><i>活</i>梯度活动</span>
                  </div>
                </div>
                <div v-if="row.merchantActivity">
                  <span style="color: orange">+{{ row.merchantActivity.rewardRate + '%' }}</span>
                  <Tooltip>
                    <Icon type="ios-help-circle-outline" style="margin-left: 3px;" size="16" />
                    <template #content>
                      <p>活动时间：{{ row.merchantActivity.startTime | filterTime('YYYY/MM/DD') }}-{{ row.merchantActivity.endTime | filterTime('YYYY/MM/DD') }}</p>
                      <p>活动名称：{{ row.merchantActivity.name }}</p>
                    </template>
                  </Tooltip>
                </div>
              </template>
              <template slot-scope="{ row }" slot="action">
                <span class="table-btn" @click="goRate(row)">查看费率</span>
                <span v-if="organShow"  class="table-btn red"  @click="delProduct(row)">删除</span>
              </template>
            </Table>
            <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList"
              show-sizer :page-size-opts="[10, 30, 50, 100]" @on-page-size-change="pageSize=$event;getList()" style="text-align: center; margin-top: 20px" />
          </div>
        </div>
      </div>

      <!-- 设置模板 -->
      <setTemplate ref="setTemplate" @success="successSetTemplate()"></setTemplate>

      <!-- 变更模板 -->
      <replaceTemplate ref="replaceTemplate" :templateDetail="templateDetail" @success="searchAjax(); getTemplateDetail(); queryStatistics();"></replaceTemplate>

      <!-- 进度弹窗 -->
      <modalLoading ref="loading"></modalLoading>

      <!-- 批量配置 -->
      <batchSetting ref="batchSetting" @success="successCallback"></batchSetting>

      <!-- 新增产品 -->
      <addProduct ref="addProduct" @success="successCallback"></addProduct>

      <!-- 恢复模板费率 -->
      <recovery-rate ref="rateModal"></recovery-rate>
      <!-- 导出历史费率 -->
      <daochu-fee-modal ref="daochuFeeModal"></daochu-fee-modal>
      <!-- 导入费率 -->
      <import-Product-fee ref="importProductFee" pageType="config" @success="successCallback"></import-Product-fee>
    </div>
  </div>
</template>

<script>
import orgTree from "@/components/commons/orgTree/orgTree";
import moveLine from "@/components/commons/moveLine";
import modalLoading from "@/components/commons/modalLoading";
import addProduct from "@/components/commons/feeTemplate/addProduct";
import batchSetting from "@/components/commons/feeTemplate/batchSetting";
import recoveryRate from './recoveryRate';
import setTemplate from './components/setTemplate';
import replaceTemplate from './components/replaceTemplate';
import daochuFeeModal from '@/components/commons/feeTemplate/daochuFeeModal';
import importProductFee from '@/components/commons/importProductFee/index';
import { config } from './config.config.js';
import { mapState } from "vuex";
import cover from './cover.vue';
import { common } from '@/api/mixins';
export default {
  mixins: [common, config],
  components: {
    orgTree,
    moveLine,
    modalLoading,
    addProduct,
    batchSetting,
    recoveryRate,
    cover,
    setTemplate,
    daochuFeeModal,
    importProductFee,
    replaceTemplate
  },
  name: "feeConfig",
  data() {
    return {
      coverShowBack: false,
      searchMore: false,
      leftWidth: 360,
            userInfo:{},
      detail: {}, //当前选择的组织数据
      templateDetail: {}, //当前选择的组织模板数据
      firstEntryPage: false,
      showRuleTips: false,
      search: {
        salesAuth: '',
        isAct: '',
        productType: ''
      }, //查询数据
      tableLoading: false, //表格loading
      templateList: [], //模板列表
      organShow: true,
      supplierList: [], //供应商
      columns: [],
      // 统计tab
      tabList: [{ num: '' }],
      changeColumns: [],
      tableData: [], //表格数据
      total: 0, //表格记录数
      pageSize: 10, //页容量
      pageNum: 1, //当前页
      isAll: false, //全部产品
      selectArr: [], //表格选择的数据
      updateTemplateVisible: false, //更换模板弹窗
      form: {}, //表单数据
      feeTemplateVisible: false, //费率表弹窗
      companyList: [],
      copyProductRate: false
    };
  },
  computed: {
    ...mapState({
      organInfo: "mechOranization",
      navList: "mechNavList",
      themeList: "themeList",//产品分类
    }),
  },
  activated(){
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    // 从模板商户跳转过来
    if(this.$route.query.id){
      this.$nextTick(()=> {
        setTimeout(() => {
          this.$refs.tree2.getTreeData(this.$route.query.id);
          let idEl = document.getElementById(this.$route.query.id);
          if(idEl){
            document.getElementById(this.$route.query.id).scrollIntoView();
          }
        }, 1000);
      })
    }else{
      if(localStorage.getItem('updataOrgAndTeam')&&localStorage.getItem('updataOrgAndTeam')==1) {
        this.$nextTick(()=> {
          this.$refs.tree2.getTreeData(this.detail.id);
        })
      }else{
        this.$nextTick(()=> {
          this.$refs.tree2.getTreeData();
        })
      }
    }
    if(this.$route.query.isThereRate){
      this.search.isThereRate=this.$route.query.isThereRate
      this.$nextTick(()=>{
        this.searchMore = true
      })
    }
    this.firstPage();
    this.queryInsuranceCompanyList();
    this.getImportFeeProgress();
  },
  methods: {
    searchFun(){
      if(this.detail.id) {
        this.searchAjax();
        this.queryStatistics()
      }
    },
    // 导入费率
    importProductFee(){
      if(!this.$units.pointAction('commission_10_5')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      let uploadUrl = '/buz/commission/config/importCommissionByOrgId?orgId=';
      if(this.detail.nodeType == 2){
        uploadUrl = '/buz/commission/config/importCommissionByGroupId?groupId=';
      }
      uploadUrl += this.detail.id;
      const params = this.getParams();
      if (this.detail.orgType == '1') {//商户
        params.organizationType = this.detail.nodeType;
        params.organizationId = this.detail.id;
      }
      params.dataLock = true;
      this.$refs.importProductFee.open({
        uploadUrl,
        nodeType: this.detail.nodeType,
        downloadUrl: '/buz/commission/config/export',
        downloadParams: params,
      })
    },
    // 获取导入产品费率进度
    getImportFeeProgress(){
      this.$refs.importProductFee.getProgress()
    },
    // 判断是否首次进入页面
    firstPage() {
      let firstTemplatePage = window.localStorage.getItem('first_template_page');
      let show = this.$route.query.show;
      if (firstTemplatePage == '0') {
        this.firstEntryPage = false;
      } else {
        this.firstEntryPage = true;
        window.localStorage.setItem('first_template_page', 0);
      }
      if (show == '1') {
        this.firstEntryPage = true;
      }
    },

    changeOriginSupplierType(value) {
      this.search.supplierIds = [];
      if (!value) {
        this.supplierList = [];
        return;
      }
      this.$http({
        url:
          value == 1
            ? "/buz/insuranceCompany/read/list"
            : "/buz/insuranceChannel/read/list",
        type: "POST",
        data: {}
      }).then(res => {
        if (value) {
          this.supplierList = res.data.map(i => {
            return {
              value: i.id,
              label: i.name
            };
          });
        } else {
          this.supplierList = [];
        }
      });
    },
    // 查询签约保司
    queryInsuranceCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/read/all',
        type: 'POST',
        data: {
          companyType: '1'
        }
      }).then(res => {
        this.companyList = res.data;
      });
    },

    // 导出当前费率
    daochu() {
      if(!this.$units.pointAction('commission_10_2')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      const params = this.getParams();
      if (this.detail.orgType == '1') {//商户
        params.organizationType = this.detail.nodeType;
        params.organizationId = this.detail.id;
      }
      this.$units.downloadFile('/buz/commission/config/export', params, 'POST', '', 'commission_10_2');
    },
    // 导出历史费率
    daochuHistory() {
      if(!this.$units.pointAction('commission_10_4')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      const params = this.getParams();
      params.apiPermissionCode = 'commission_10_4';
      if (this.detail.orgType == '1') {//商户
        params.organizationType = this.detail.nodeType;
        params.organizationId = this.detail.id;
      }
      this.$refs.daochuFeeModal.open(params);
    },

    initData() {
      this.$store.dispatch("getCompanyList");
      this.$store.dispatch("getThemeList");
    },

    // 切换tab
    handClickTabs(value) {
      this.tab = value;
      this.getList();
    },

    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },

    // 删除产品
    delProduct(item) {
      if(!this.$units.pointAction('commission_10_1')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.$notice.inquiry("确定删除产品？").then(() => {
        this.$http({
          url: "/buz/productBase/remove/product",
          type: "POST",
          data: {
            organizationId: item.organizationId,
            organizationType: this.detail.nodeType,
            productCodes: [item.productCode],
            isAll: 0,
            ...this.search
          },
          apiPermissionCode:'commission_10_3'
        }).then(res => {
          this.$notice.success("删除产品成功");
          this.searchAjax();
        })
      });
    },

    // 获取模板详情
    getTemplateDetail() {
      this.$http({
        url: "/buz/organizationTemplate/getTemplate",
        type: "post",
        data: {
          organizationType: this.detail.nodeType,
          organizationId: this.detail.id
        }
      }).then(res => {
        this.templateDetail = res.data || {};
      })
    },

    // 设置模板成功
    successSetTemplate() {
      this.searchAjax();
      this.getTemplateDetail();
      this.$refs.tree2.getTreeData(this.detail.id);
    },

    // 不在应用模板
    noTemplate() {
      if(!this.$units.pointAction('commission_10_1')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.$notice.inquiry(`确定不再应用模板？<div style='color:#a39f9f;margin-top:5px;font-size:14px;'>注：不再应用模板不改变机构/团队现有产品和费率</div>`).then(()=>{
        this.tableLoading = true;
        this.$refs.loading.open({
          title: '正在联动调整产品服务费，请稍等',
          content: '系统将自动根据下级占上级的服务费占比联动调整相关机构或团队的产品服务费',
          descText: '（如，上级为80%，下级为40%，即下级占上级费率的50%，当上级下调至30%时，系统将自动根据上下级的原服务费占比，进行下调，即下级调至15%）'
        });
        this.$http({
          url: "/buz/organizationTemplate/cancel",
          type: "POST",
          data: {
            organizationId: this.detail.id,
            organizationType: this.detail.nodeType,
            templateId: this.templateDetail.id
          }
        }).then(res => {
          this.$refs.tree2.getTreeData(this.detail.id);
          this.getTemplateDetail();
          this.searchAjax();
          this.tableLoading = false;
          if(res.httpCode == 1){
            this.$refs.loading.setText({ progress: 100 });
          }else{
            this.$refs.loading.open({
              title: '调度失败!',
              progress: 99,
            });
          }
        }).catch(e => {
            this.$refs.loading.open({
              title: '调度失败!',
              progress: 99,
            });
          });
      });
    },

    // 费用配置方式介绍
    showCommissionExplain() {
      this.firstEntryPage = !this.firstEntryPage;
      this.coverShowBack = true;
    },

    goTemplateDetail() {
      this.openPageTabTags(
          '/productResource/fee/config/templateDetail',
          {
            id: this.templateDetail.id,
            type: this.templateDetail.type,
            orgId: this.templateDetail.orgId,
            redirectPagePath: 'commissionConfig'
          }
      );
    },

    // 打开变更模板弹窗
    openChangeTemplate(key) {
      if(!this.$units.pointAction('commission_10_1')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      if (key == 'setTemplateVisible') {
        this.$refs.setTemplate.open(true, this.detail, this.templateDetail.id);
      } else {
        this.$refs.replaceTemplate.open(false, this.detail, this.templateDetail.id);
      }
    },

    // 恢复模板费率
    recoveryTemplate() {
      if(!this.$units.pointAction('commission_10_1')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.$refs.rateModal.open({
        title: "恢复模板费率",
        content: "当前组织的产品和费率将完全重置为模板内的数据，请确认是否恢复？"
      }).then(async () => {
        this.$refs.loading.open({
          title: "正在联动调整产品服务费，请稍等",
          content: "系统将自动根据下级占上级的服务费占比联动调整相关机构或团队的产品服务费",
          descText: '（如，上级为80%，下级为40%，即下级占上级费率的50%，当上级下调至30%时，系统将自动根据上下级的原服务费占比，进行下调，即下级调至15%）'
        });
        this.$http({
          url: '/buz/commissionSpecial/removeByOrg',
          type: 'POST',
          data: {
            orgId: this.detail.id,
            orgType: this.detail.nodeType
          },
        }).then((res) => {
          if(res.httpCode == 1){
            this.$refs.loading.setText({ progress: 100 });
            this.getList();
          }else{
            this.$refs.loading.setText({
              title: `调整失败！`,
              progress: 99
            });
          }
        }).catch(() => {
          this.$refs.loading.setText({
            title: `调整失败！`,
            progress: 99
          });
        });
      });
    },

    // 批量删除
    batchDelete() {
      if(this.tableLoading){
        return;
      }
      if(!this.$units.pointAction('commission_10_1')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      if (this.selectArr.length == 0 && !this.isAll) {
        this.$notice.msg("请至少选择一个产品")
        return;
      }
      const productCodes = [];
      this.selectArr.forEach(item => {
        productCodes.push(item.productCode);
      });
      let data = {
        organizationId: this.detail.id,
        organizationType: this.detail.nodeType,
        productCodes,
        ...this.search
      };
      if (this.isAll) {
        data.isAll = 1;
        delete data.productCodes
      } else {
        data.isAll = 0;
      }
      this.$notice.inquiry("确定删除产品？").then(() => {
        this.tableLoading = true;
        this.$http({
          url: "/buz/productBase/remove/product",
          type: "POST",
          data
        }).then(res => {
          this.selectArr = [];
          this.isAll = false;
          this.$notice.success("删除产品成功");
          this.searchAjax();
        }).fianlly(()=>{
          this.tableLoading = false;
        })
      });
    },

    // 打开批量配费
    openBatchSetting() {
      if(!this.$units.pointAction('commission_10_1')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      if (this.selectArr.length == 0 && !this.isAll) {
        this.$notice.msg("请至少选择一个产品")
        return;
      }
      const isLongOrShort = [false, false];
      const productCodes = [];
      this.selectArr.forEach(item => {
        productCodes.push(item.productCode);
        if (item.productType == 1) {
          isLongOrShort[0] = true;
        }
        if (item.productType == 2) {
          isLongOrShort[1] = true;
        }
      });
      this.$refs.batchSetting.open({
        templateId: this.templateDetail.id,
        isAll: this.isAll,
        orgId: this.detail.id,
        isLongOrShort: isLongOrShort,
        productCodes: this.isAll ? [] : productCodes,
        type: this.detail.nodeType,
        isConfig: true,
        search: this.search,
        isCommon: true,
        apiPermissionCode:'commission_10_2'
      });
    },

    // 跳转费率表
    goRate(item) {
      this.openPageTabTags(
          '/productResource/fee/rateDetail',
          {
            id: item.organizationId,
            nodeType: this.detail.nodeType,
            productCode: item.productCode,
            isTemplate: item.isTemplate,
            sourceType: item.sourceType,
            publishStatus: item.publishStatus,
            mechanName: this.detail.name,
            productName: item.productName,
            companyName: item.companyName,
            organShow: this.organShow,
            showRateTag:this.templateDetail.id,
            pageType: 'merchant',
            id: this.detail.id,
            isTop:this.detail.isTop
          }
      );
    },

    // 跳转费率变更记录
    goRateChangeRecord(item) {
      this.openPageTabTags(
          '/productResource/fee/rateChangeRecord',
          {
            id: item.organizationId,
            nodeType: this.detail.nodeType,
            productCode: item.productCode,
            productName: item.productName,
          }
      );
    },

    // 新增产品弹窗
    openAddProductModal() {
      if(!this.$units.pointAction('commission_10_1')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      const data = Object.assign({ handleSource: 2 }, this.detail);
      data.template = {
        id: this.templateDetail.id
      };
      data.isCommissionConfig = true;
      this.$refs.addProduct.open(data);
    },

    // 列表选中
    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.id); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.id); //已经添加的数据
      this.tableData.forEach(item => {
          if (ids.includes(item.id) && !selectIds.includes(item.id)) {
              //未添加已勾选的数据时添加数据
              this.selectArr.push(item);
              selectIds.push(item.id);
          } else if (!ids.includes(item.id) && selectIds.includes(item.id)) {
              //添加了未勾选的数据时删除
              this.selectArr.splice(selectIds.indexOf(item.id), 1);
              selectIds.splice(selectIds.indexOf(item.id), 1);
          }
      });
    },

    // 直接配费
    directFee() {
      this.firstEntryPage = false;
      window.localStorage.setItem('first_template_page', 0);
    },

    // 模板配费
    templateFee() {
      window.localStorage.setItem('first_template_page', 0);
      this.$router.push({
        path: '/productResource/fee/templateList'
      })
    },

    async treeChange(cur) {
      if(!localStorage.getItem('updataOrgAndTeam')) {
        delete this.search.productName;
        delete this.search.productCode;
        delete this.search.companyCode;
        delete this.search.productType;
        delete this.search.themeId;
        delete this.search.supplierIds;
        delete this.search.salesAuth;
        delete this.search.isAct;
      }
      if(!localStorage.getItem('updataOrgAndTeam') && this.$units.superviseShowVal()) {
        delete this.search.supplierType;
      }
      if (!cur.id) {
        return;
      }
      if (sessionStorage.feeConfigData_curOrg) {
        try {
          this.detail = JSON.parse(sessionStorage.feeConfigData_curOrg);
        } catch (error) {
          this.detail = cur;
        }
        sessionStorage.removeItem("feeConfigData_curOrg");
        this.$store.commit("setMechNavList", {
          id: this.detail.id,
        });
        this.detail = this.navList[this.navList.length - 1];
      } else {
        this.detail = cur;
      }
      this.changeColumns = []
      if (cur.id == JSON.parse(localStorage.userInfo).organId) {
        if(this.detail.isTop){
          this.organShow = false;
          this.columns.forEach(item=>{
            if(item.type != "selection"){
              this.changeColumns.push(item);
            }
          })
        }else if(this.detail.id == this.userInfo.organId) {
          this.organShow = false;
          this.columns.forEach(item=>{
            if(item.type != "selection"){
              this.changeColumns.push(item);
            }
          })
        }else{
          this.changeColumns = this.columns;
        }
      } else {
        this.organShow = true;
        this.changeColumns = this.columns;
      }
      this.tableData = [];
      this.selectArr = [];
      this.isAll = false;
      this.pageNum = 1;
      this.queryStatistics();
      this.getList();
      this.getTemplateDetail();
    },

    // 复制上级产品和费率
    inheritProductRate(){
      if(!this.$units.pointAction('commission_10_1')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.$Modal.confirm({
          title: '确定复制上级产品和费率吗？',
          onOk: () => {
            this.copyProductRate = true;
            this.$refs.loading.open({
              title: '正在联动调整产品服务费，请稍等',
              content: '系统将自动根据下级占上级的服务费占比联动调整相关机构或团队的产品服务费',
              descText: '（如，上级为80%，下级为40%，即下级占上级费率的50%，当上级下调至30%时，系统将自动根据上下级的原服务费占比，进行下调，即下级调至15%）'
            });
            this.$http({
              url: "/buz/organizationProduct/copyParent",
              type: "post",
              data: {
                organizationId:this.detail.id,
                organizationType:this.detail.nodeType,
              },
            }).then(res => {
              this.getList();
              this.getTemplateDetail();
              this.copyProductRate = false;
              if(res.httpCode == 1){
                this.$refs.loading.setText({ progress: 100 });
              }else{
                this.$refs.loading.open({
                  title: '调度失败!',
                  progress: 99,
                });
              }
            }).catch(()=>{
              this.copyProductRate = false;
                this.$refs.loading.open({
                title: '调度失败!',
                progress: 99,
              });
            })
          }
      });
    },

    // 获取列表参数
    getParams() {
      const params = Object.assign({}, this.search);
      params.nodeType = this.detail.nodeType;
      params.id = this.detail.id;
      params.handleSource = 2;
      return params;
    },

    searchAjax() {
      this.isAll = false; //全选
      this.selectArr = [];
      this.pageNum = 1;
      this.getList();
    },

    // 获取列表数据
    getList() {
      const params = this.getParams();
      params.pageNo = this.pageNum;
      params.pageSize = this.pageSize;
      if (this.tab == 2) {
        params.hasRate = 1;
      } else if (this.tab == 3) {
        params.hasRate = 0;
      }
      this.tableLoading = true;
      this.$http({
        url: "/buz/organizationProduct/query/page",
        type: "post",
        data: params,
        apiPermissionCode:'commission_10_0'
      }).then(res => {
        res.data.forEach(item => {
            this.selectArr.forEach(item2 => {
                if (item.id == item2.id) {
                    item._checked = true;
                }
            });
            if (this.isAll) {
                item._checked = true;
                item._disabled = true;
            }
        });
        this.tableLoading = false;
        this.tableData = res.data;
        this.total = res.total;
        this.initData();
      }).catch(e => {
        this.tableLoading = false;
      })
    },

    // 列表tabs统计
    queryStatistics() {
      let params = this.getParams();
      this.$http({
        url: "/buz/organizationProduct/statistics",
        type: "POST",
        data: params
      }).then(res => {
        let { all, hasRate, noRate } = res.data;
        this.tabList[0].num = all;
        // this.tabList[1].num = hasRate;
        // this.tabList[2].num = noRate;
      })
    },

    // 产品新增成功
    successCallback() {
      this.selectArr = [];
      this.isAll = false;
      this.searchAjax();
      this.queryStatistics();
    }
  },
};
</script>
<style lang="scss" scoped>@import "./config.scss";</style>